export default __webpack_public_path__ + "static/better-evets-less-staff-time-2a33291c7f74e650496865d1e0ff2253.jpg";